import { render, staticRenderFns } from "./channelConfig.vue?vue&type=template&id=7e6d1325&"
import script from "./channelConfig.vue?vue&type=script&lang=js&"
export * from "./channelConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e6d1325')) {
      api.createRecord('7e6d1325', component.options)
    } else {
      api.reload('7e6d1325', component.options)
    }
    module.hot.accept("./channelConfig.vue?vue&type=template&id=7e6d1325&", function () {
      api.rerender('7e6d1325', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpOpsManager/channelConfig.vue"
export default component.exports